import { useEffect, useState } from 'react';

export function useProjectNameEditing({
  defaultProjectName,
  projectSlot,
  onRenameProject,
} = {}) {
  const initialName = String(projectSlot?.name || defaultProjectName || '').trim();
  const [projectNameEditing, setProjectNameEditing] = useState(false);
  const [projectNameDraft, setProjectNameDraft] = useState(initialName);
  const [projectDisplayName, setProjectDisplayName] = useState(initialName);

  const resolvedProjectName = String(projectSlot?.name || defaultProjectName || '').trim();

  useEffect(() => {
    setProjectDisplayName(resolvedProjectName);
    if (!projectNameEditing) {
      setProjectNameDraft(resolvedProjectName);
    }
  }, [projectNameEditing, resolvedProjectName]);

  const handleProjectNameStartEdit = (selectedProject) => {
    if (!selectedProject?.key) {
      return;
    }
    setProjectNameDraft(String(selectedProject?.name || projectDisplayName || '').trim());
    setProjectNameEditing(true);
  };

  const handleProjectNameCancel = () => {
    setProjectNameEditing(false);
    setProjectNameDraft('');
  };

  const handleProjectNameSave = async () => {
    const nextName = String(projectNameDraft || '').trim();
    if (!nextName || !projectSlot?.key) {
      return;
    }
    await onRenameProject?.(projectSlot, nextName);
    setProjectDisplayName(nextName);
    handleProjectNameCancel();
  };

  return {
    projectNameEditing,
    projectNameDraft,
    setProjectNameDraft,
    projectDisplayName,
    handleProjectNameStartEdit,
    handleProjectNameCancel,
    handleProjectNameSave,
  };
}

export default useProjectNameEditing;
